module.exports = __webpack_public_path__ + "img/67.69f23ee.png";